export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const DISPOSE_NOTIFICATION = 'DISPOSE_NOTIFICATION';
